import moment from 'moment-timezone';
import AppConstants from '../AppConstants';

export function initializeAppcues(user, metadata = {}) {
  const accountAgeDays = getAccountsAgeInDays(user.created);
  const newUser = moment(user.created).isAfter(moment('2018-09-04T07:00:00.000Z')); // 9/4/2018 e2e was ga
  const userMetadata = {
    accountKey: user.accountKey,
    seats: user.seats,
    plan: metadata.description,
    type: metadata.channel,
    language: user.userLocale,
    createdAtDate: user.created,
    accountAgeDays,
    newUser,
    serviceType: metadata.serviceType
  };
  if (AppConstants.APPCUES_ENABLED && window.Appcues) {
    window.Appcues.identify(user.userKey, userMetadata);
  }
}

export function appCuesPage() {
  if (AppConstants.APPCUES_ENABLED && window.Appcues) {
    window.Appcues.page();
  }
}

function getAccountsAgeInDays(date) {
  const end = moment(date);
  const start = moment();
  return Math.floor(moment.duration(start.diff(end)).asDays());
}



// WEBPACK FOOTER //
// ./src/Utils/Appcues.js